<template>
  <v-dialog v-model="show" max-width="380" persistent>
    <v-card class="pb-6 pt-8 px-10 text-center" rounded="xl">
      <div class="text-h4 mb-6">🚀</div>
      <h3 class="text-h6 font-weight-bold mb-2">恭喜您完成導覽</h3>
      <div class="text-body-2 tiffany-9--text font-weight-medium">
        現在即可免費建立醫師專屬頁面，<br>
        打造網路個人形象，讓患者更認識你！
      </div>
      <div class="mt-10">
        <v-btn color="tiffany-9" dark elevation="0" block :href="$enum.DENTCO_CS_LINE" target="_blank" @click="close">聯繫客服，了解更多「訂閱升級功能」</v-btn>
        <v-btn outlined block color="grey-4" class="mt-5 grey-5--text" @click="close">完成導覽，關閉視窗</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EndOnBoard',
  data() {
    return {
      show: true
    }
  },
  methods: {
    close() {
      localStorage.removeItem('isNewUser');
      this.show = false
      this.$emit('start')
    }
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
